import React from "react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apolloClient.js";
import { GlobalStyles } from "./themes/GlobalStyles";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./themes/ThemeContext";
import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes";
import { LoadingProvider } from "./contexts/LoadingContext";
import { SchemaProvider } from "./components/SchemaProvider/SchemaProvider";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatabaseProvider } from './contexts/DatabaseContext';
import { RbacProvider } from "./hooks/RbacContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const AppContent = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <ThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <RbacProvider>
            <LoadingProvider>
              <GlobalStyles />
              <ErrorBoundary>
                <DndProvider backend={HTML5Backend}>
                  <SchemaProvider>
                    <AppRoutes />
                  </SchemaProvider>
                </DndProvider>
              </ErrorBoundary>
            </LoadingProvider>
            </RbacProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </LocalizationProvider>
  );
};

const App = () => {
  return (
    <DatabaseProvider>
      <ApolloProvider client={client}>
        <AppContent />
      </ApolloProvider>
    </DatabaseProvider>
  );
};

export default App;
